import { Alert } from "@mui/material";
import WarningIcon from "@/app/csr-src/assets/icons/WarningIcon.svg";

interface MinimumPaymentFlagType {
  text: string;
}

const MinimumPaymentFlag = ({ text }: MinimumPaymentFlagType) => {
  return (
    <Alert
      icon={<WarningIcon fontSize="#FBB731" />}
      severity="warning"
      sx={{
        ".MuiPaper-root-MuiAlert-root": {
          color: "#C99227",
          backgroundColor: "#FFF8EA",
          border: "1px solid #FDE2AD",
          borderRadius: "8px",
        },
      }}
    >
      {text}
    </Alert>
  );
};

export default MinimumPaymentFlag;
